import React from 'react';
import '../../../styles/global.css';

function WhackAMole() {
  return (
    <div className="body-container">
      <h1>Whack-a-Mole</h1>
      <h4>Aug 2022 - Nov 2023</h4>
      <p>A student-animated short film following the internal moral conflict of a young boy after he plays Whack-a-Mole at an arcade.</p>
      <h3>Contributions:</h3>
      <li>Original concept</li>
      <li>Storyboarding</li>
      <li>Modeling of gummy worm</li>
      <li>Texturing of arcade machines (<a href='#models'>below</a>)</li>
      <br />
      <div className='iframe-container'>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/kzBTH7tyRXY?si=_mY3poM2i_gBuhQm" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
      </div>
      <br />
      <h3 id='models'>Texturing:</h3>
      <li>Pangolin Pinball Machine</li>
      <div className='imgs-grid'>
        <img src={require('./assets/pinball_render2.png')} alt="pinball render 2" />
        <img src={require('./assets/pinball_render4.png')} alt="pinball render 4" />
        <img src={require('./assets/pinball_render3.png')} alt="pinball render 3" />
        <img src={require('./assets/pinball_render5.png')} alt="pinball render 5" />
      </div>
      <br />
      <li>Polar Puncher Machine</li>
      <div className='imgs-grid'>
        <img src={require('./assets/punch_machine_render1.png')} alt="punch machine render 1" />
        <img src={require('./assets/punch_machine_render4.png')} alt="punch machine render 4" />
        <img src={require('./assets/punch_machine_render3.png')} alt="punch machine render 3" />
        <img src={require('./assets/punch_machine_render5.png')} alt="punch machine render 5" />
      </div>
    </div>
  );
};

export default WhackAMole;
